import React, { useEffect, useState } from "react";

import { Formik, Form } from "formik";

import providerManagerDashboardApi from "apis/providerManagerDashboard";
import usersApi from "apis/users";
import { Button, PageLoader } from "clearsense-ui/components";
import { Select, Textarea } from "clearsense-ui/components/formik";
import PermissibleWrapper from "components/Common/PermissibleWrapper";
import convertToSelectOptions from "utils/convertToSelectOptions";

const StatusDetails = ({
  isViewMode,
  userPermissions,
  currentNPIRecord,
  searchParams,
  handleSearch,
}) => {
  const [owners, setOwners] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchOwners = async () => {
    setIsLoading(true);
    try {
      const { data } = await usersApi.fetch(1, 100, "");
      setOwners(data.users);
    } catch (err) {
      logger.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchOwners();
  }, []);

  const handleSave = async values => {
    try {
      await providerManagerDashboardApi.update(
        searchParams.provider_manager_dashboard.npi,
        {
          status: values.status.value,
          owner_id: values.owner.value,
          comments: values.comments,
        }
      );
      await handleSearch({ npi: searchParams.provider_manager_dashboard.npi });
    } catch (err) {
      logger.log(err);
    }
  };

  if (isLoading) return <PageLoader />;

  return (
    <Formik
      enableReinitialize
      initialValues={{
        status: {
          label: currentNPIRecord.status,
          value: currentNPIRecord.status,
        },
        owner: {
          label: owners?.find(owner => owner.key === currentNPIRecord.owner_id)
            ?.name,
          value: currentNPIRecord.owner_id,
        },
        comments: currentNPIRecord.comments,
      }}
      onSubmit={handleSave}
    >
      {formik => (
        <Form>
          <div className="bg-white p-10 rounded w-full space-y-3">
            <Select
              name="status"
              label="Status"
              options={convertToSelectOptions(
                [
                  "Created Entity",
                  "Provider Onboarded",
                  "Credentialing Updated",
                  "Provider Data Validated",
                ],
                { isSort: false }
              )}
              isDisabled={isViewMode}
            />
            <Select
              name="owner"
              label="Owner"
              options={owners.map(owner => ({
                key: owner.key,
                label: owner.name,
                value: owner.key,
              }))}
              isDisabled={isViewMode}
            />
            <Textarea name="comments" label="Comments" disabled={isViewMode} />
          </div>

          <PermissibleWrapper
            currentPermissions={userPermissions}
            acceptablePermissions="update"
          >
            {!isViewMode && (
              <Button
                type="submit"
                label="Save"
                size="large"
                className="float-right mt-8"
                disabled={!formik.dirty}
                loading={formik.isSubmitting}
              />
            )}
          </PermissibleWrapper>
        </Form>
      )}
    </Formik>
  );
};

export default StatusDetails;
